module.exports = __webpack_public_path__ + "static/media/cyclingquiz.bf6a321b.gif";